let chatwootLoaded = false;
let chatwootReady = false;

function login_chat(isProduction) {
    if (!isProduction) {
        hidden_chat();
        return;
    }

    const localStorageUser = localStorage.getItem('user');

    if (!localStorageUser) {
        hidden_chat();
        return;
    }

    const user = JSON.parse(localStorageUser);

    if (!user) {
        hidden_chat();
        return;
    }

    const config = window.chatWootConfig || {};

    // if ((config.blocked_companies || []).includes(String(user.company))) {
    //     hidden_chat();
    //     return;
    // }

    if (chatwootLoaded) {
        if (chatwootReady) loadUserData(user);

        showChatWidget();
        return;
    }

    chatwootLoaded = true;

    const g = document.createElement('script');
    g.src = config.chatWoot_Url + '/packs/js/sdk.js';
    g.defer = true;
    g.async = true;

    document.head.appendChild(g);

    g.onload = function () {
        window.chatwootSDK.run({
            websiteToken: config.chatWoot_Token,
            baseUrl: config.chatWoot_Url
        });

        window.addEventListener('chatwoot:ready', function () {
            chatwootReady = true;
            loadUserData(user);
            showChatWidget();
        }, { once: true });
    };
}

function loadUserData(user) {
    if (!window.$chatwoot) return;

    window.$chatwoot.setUser(user._id, {
        email: user.email,
        name: `${user.firstName} ${user.lastName}`
    });
}

function showChatWidget() {
    if (window.$chatwoot) window.$chatwoot.toggleBubbleVisibility('show');

    var chatWootDiv = document.getElementById('cw-bubble-holder');
    if (!chatWootDiv) return;

    chatWootDiv.style.display = 'block';
}

function hidden_chat() {
    try {
        if (window.$chatwoot) {
            window.$chatwoot.toggle('close'); // Minimiza o chat  
            window.$chatwoot.toggleBubbleVisibility('hide');
        }

        var chatWootDiv = document.getElementById('cw-bubble-holder');
        if (!chatWootDiv) return;

        chatWootDiv.style.display = 'none';
    } catch (err) {}
}

function logout_chat() {
    try {
        // window.$chatwoot.reset(); // Não vamos resetar o chat, pois precisamos manter as msgs.
        hidden_chat();
    } catch (err) {}
}